import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './index.scss';
import avatar from 'assets/images/avatar.png';
import {
    MultiSelect,
} from 'components';
import {
    HomeContext,
    MemberContext,
    OrganizationContext,
    TeamContext,
} from 'contexts';
import {
    CONSIGNEE,
    EXPORT_CUSTOMS,
    EXPORT_LOGISTICS,
    FREIGHT,
    IMPORT_CUSTOMS,
    IMPORT_LOGISTICS,
    MARK_BOOKING_REQUEST,
    MARK_NEW,
    MARK_TRACK_SHIPMENT,
    MEMBER,
    SHIPPER,
    TEAM
} from 'actions';
import { GET_FILE, OTHERS, SHIPMENT_ADMIN } from 'actions/constants';
import { useTranslation } from 'react-i18next';
import { Dropdown, Input } from 'components/common';
import { getErrorMessage } from 'utils';

const MEMBER_U = MEMBER.toUpperCase();
const TEAM_U = TEAM.toUpperCase();

export const AddPartnersForm =   ({
    register = () => {},
    errors,
    selectedValues = [],
    setSelectedValues = () => {},
    shipmentDetail,
    setSelectedGroups,
    selectedGroups,
    setSelectedAdminGroups,
    selectedAdminGroups,
    adminGroups, 
    setAdminGroups,
    groups, 
    setGroups
}) => {
    const [t] = useTranslation();
    const {
        markAsShipmentType,
        markAsShipmentTemplate,
        trackerTemplate
    } = useContext(HomeContext);
    // const { partners, doGetPartners } = useContext(ActiveShipmentsContext);
    const { doGetOrgMembers } = useContext(MemberContext); 
    const { doGetOrgTeams } = useContext(TeamContext);
    const [organizations, setOrganzations] = useState([]);
    const { allOrganizations, doGetAllOrganizations } = useContext(OrganizationContext);

    const [shipmentAdmin, setShipmentAdmin] = useState([]);
    const [shipper, setShipper] = useState([])
    const [consignee, setConsignee] = useState([]);
    const [exportCustom, setExportCustom] = useState([]);
    const [freightPartner, setFreightPartner] = useState([]);
    const [exportLogistics, setExportLogistics] = useState([]);
    const [importCustom, setImportCustom] = useState([]);
    const [importLogistics, setImportLogistics] = useState([]);
    const [allPartners, setAllPartners] = useState([]);
    const [partners, setPartners] = useState([]);
    // const [adminGroups, setAdminGroups] = useState([0]);
    // const [groups, setGroups] = useState([0]);
    const [currentOrg, setCurrentOrg] = useState(null);
    const inviteByEmail = 'Invite by email';

    /*eslint-disable */
    useEffect(() => {
        doGetAllOrganizations({
            page: 0,
            limit: 999,
            tab: OTHERS
        }, (data) => {
            setOrganzations(data)

        })
    }, [])

    useEffect(() => {
        selectedValues.forEach( async value => {
            if (value.roleType === SHIPMENT_ADMIN && !shipmentAdmin.length) setShipmentAdmin(value.partners);
            if (value.roleType === SHIPPER && !shipper.length) setShipper(value.partners);
            if (value.roleType === CONSIGNEE && !consignee.length) setConsignee(value.partners);
            if (value.roleType === EXPORT_CUSTOMS && !exportCustom.length) setExportCustom(value.partners);
            if (value.roleType === FREIGHT && !freightPartner.length) setFreightPartner(value.partners);
            if (value.roleType === EXPORT_LOGISTICS && !exportLogistics.length) setExportLogistics(value.partners);
            if (value.roleType === IMPORT_CUSTOMS && !importCustom.length) setImportCustom(value.partners);
            if (value.roleType === IMPORT_LOGISTICS && !importLogistics.length) setImportLogistics(value.partners);
        });
    }, [selectedValues])

    useEffect(() => {
        if (shipmentDetail) {
            // Do binding previous partners
        }
        if (markAsShipmentType !== MARK_NEW) {
            switch(markAsShipmentType) {
                case MARK_TRACK_SHIPMENT:
                    if (trackerTemplate) {

                    }
                    break;
                case MARK_BOOKING_REQUEST:
                    if (markAsShipmentTemplate && !selectedValues.length) {
                        const { memberInfo, freight, creatorRole, base } = markAsShipmentTemplate;
                        let freights = [];
                        let creators = [];
                        let collaborators = [];

                        memberInfo.forEach(m => {
                            if (m.id === freight.freightId) freights.push({
                                ...m,
                                type: freight.freightType,
                                email: m.email,
                            });
                            else if (m.id === base.createdBy) creators.push({
                                ...m,
                                type: MEMBER_U,
                                email: m.email
                            });
                            else {
                                collaborators.push({
                                    ...m,
                                    type: MEMBER_U,
                                    email: m.email
                                })
                            };
                        });

                        setFreightPartner(old => [...old, ...mappingPartners(freights)]);
                        handleAddPartner(mappingPartners(freights), FREIGHT);
                        switch(creatorRole) {
                            case CONSIGNEE:
                                setConsignee(old => [...old, ...mappingPartners(creators), ...mappingPartners(collaborators)]);
                                handleAddPartner(mappingPartners([...creators, ...collaborators]), CONSIGNEE);
                                break;
                            case SHIPPER:
                                setShipper(old => [...old, ...mappingPartners(creators), ...mappingPartners(collaborators)]);
                                handleAddPartner(mappingPartners([...creators, ...collaborators]), SHIPPER);
                                break;
                        };

                    }
                    break;
                default:
                    break;
            }
        }
    }, [markAsShipmentType, markAsShipmentTemplate, trackerTemplate])

    /*eslint-enable */

    const mappingPartners = source => {
        return source.map(m => {
            return {
                id: m.id,
                icon: m.type === TEAM_U ? 'icon-users' : (m.avatar ? GET_FILE + m.avatar : avatar),
                title: m.username,
                description: m.type === TEAM_U ? m.organization.name : m.email,
                type: m.type,
            }
        })
    }

    const handleAddPartner = (items, roleType) => {
        if (!items.length) return;
        // doGetPartners();
        const partner = items.map(item => {
            return {
                ...item,
                id: item && item.description !== inviteByEmail && item.id,
                description: item.description,
                title: item.title,
                icon: item.icon,
                type: item.type ||  MEMBER.toUpperCase()
            }
        });
        if (selectedValues.length > 0) {
            let isExisted = false;
            selectedValues.map((e) => {
                if (e.roleType === roleType) {
                    e.partners = e.partners.concat(partner);
                    isExisted = true;
                }
                return e;
            });
            if (!isExisted) {
                let roleShipment  = { roleType: roleType, partners : partner };
                selectedValues = selectedValues.concat(roleShipment);
            }
            setSelectedValues(selectedValues);
        } else {
            let roleShipment  = { roleType: roleType, partners : partner };
            setSelectedValues(oldValue => [...oldValue, roleShipment]);
        }
    }

    const getMembersTeams = (value) => {
        if (value.length > 0) {
            const filteredPartners = allPartners.filter(partner => (partner?.name.toLowerCase().includes(value.toLowerCase()) || partner?.email.toLowerCase().includes(value.toLowerCase())));
            setPartners(filteredPartners)
        } else {
            setPartners([])
        }
        
    }

    /*eslint-disable */
    useEffect(() => {
        if (currentOrg) {

            doGetOrgMembers({
                orgId: currentOrg,
                page: 0,
                limit: 0,
                isSearching: true
            }, (memberData) => {
                doGetOrgTeams({
                    orgId: currentOrg,
                    isSearching: true
                }, (teamData) => {
                    let memberList = memberData.items.map(mem => {
                        return {
                            _id: mem._id,
                            name: mem.name,
                            email: mem.email,
                            avatar: mem.avatar || "",
                            type: MEMBER_U
                        }
                    })
                    let teamList =  teamData.items.map(team => {
                        return {
                            _id: team._id,
                            name: team.name,
                            type: TEAM_U,
                            email: "",
                            avatar: ""
                        }
                    })
                    let newPartners = memberList.concat(teamList)
                    setAllPartners(newPartners);
                    // setPartners(newPartners)
                });
            });
           
        }
        
    }, [currentOrg])
    /*eslint-enable */

    const onSearchOrganization = (value) => {
        if (organizations) {
            const filterOrgs = allOrganizations.filter(org => org.name.toLowerCase().includes(value.toLowerCase()));
            setOrganzations(filterOrgs)
        }
    }

    const handleAddGroup = () => {
        setGroups(old => [...old, old.length]);
        setSelectedGroups(old => [...old, {
            orgId: "",
            partners: []
        }]);
    }

    const handleAddGroupAdmin = () => {
        setAdminGroups(old => [...old, old.length]);
        setSelectedAdminGroups(old => [...old, {
            orgId: "", 
            partners: []
        }]);
    }

    const handleChooseOrg = (value, groupNumber, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            newSelectedGroup[groupNumber].orgId = value.key;
            setSelectedAdminGroups(newSelectedGroup);
            
        } else {
            let newSelectedGroup = [...selectedGroups];
            newSelectedGroup[groupNumber].orgId = value.key;
            setSelectedGroups(newSelectedGroup);
        }
        
        setCurrentOrg(value.key);
    }

    const handleChoosePartners = (value, groupNumber, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            let newPartner = {
                id: value[0].id,
                name: value[0].email,
                type: value[0].type,
                avatar: value[0].icon,
                orgId: newSelectedGroup[groupNumber].orgId,
                role: newSelectedGroup[groupNumber].roleType = SHIPMENT_ADMIN
            }
            newSelectedGroup[groupNumber].partners.push(newPartner);
            
            setSelectedAdminGroups(newSelectedGroup)
        } else {
            let newSelectedGroup = [...selectedGroups];
            let newPartner = {
                id: value[0].id,
                name: value[0].email,
                type: value[0].type,
                avatar: value[0].icon,
                orgId: newSelectedGroup[groupNumber].orgId,
                role: ""
            }
            newSelectedGroup[groupNumber].partners.push(newPartner);

            
            setSelectedGroups(newSelectedGroup)
        }

        setPartners([])
       
    }

    const handleChangeRoleName = (value, groupNumber, memberId) => {
        let newSelectedGroup = [...selectedGroups];
        newSelectedGroup[groupNumber].partners[memberId].role = value;
        setSelectedGroups(newSelectedGroup)
    }
    const handleRemovePartner = (groupNumber, memberId, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            let filteredMembers = newSelectedGroup[groupNumber].partners.filter(member => member.id !== memberId); 
            newSelectedGroup[groupNumber].partners = filteredMembers;
            setSelectedAdminGroups(newSelectedGroup)
        } else {
            let newSelectedGroup = [...selectedGroups];
            let filteredMembers = newSelectedGroup[groupNumber].partners.filter(member => member.id !== memberId); 
            newSelectedGroup[groupNumber].partners = filteredMembers;
            setSelectedGroups(newSelectedGroup)
        }
       
    }

    return (
        <div className="tr__add-partners-form">
            <div className="tr__add-partners-form--group mbx2">
                <div className="col-12">
                <div className="col-12 px2 d-flex flex-wrap">
                    {adminGroups.map((group, groupIndex) => (
                    <div className="col-4" key={groupIndex}>
                        <Dropdown
                            className="select big-label px4"
                            icon="icon-chevron-down"
                            iconPosition="right"
                            mode="input"
                            name="organization"
                            label={t("home.active-shipment.choose-your-organization")}
                            options={organizations && organizations.length > 0 ? organizations.map(org => {
                                return {
                                    key: org._id,
                                    value: org.name
                                }
                            }) : []}
                            placeholder={t("home.active-shipment.select-organization")}
                            dropdownPosition="center"
                            onChange={value => handleChooseOrg(value, groupIndex, SHIPMENT_ADMIN)}
                            onInputChange={onSearchOrganization}
                            // searchLoading={orgLoading}
                            // refs={register({ required: !markAsShipmentTemplate })}
                            // refs={register({ required: true })}
                        // error={!!errors.organization}
                        // errorMessage={getErrorMessage(errors.organization, "Organization")}
                        />
                        <MultiSelect
                            className={`${!selectedAdminGroups[groupIndex]?.orgId ? 'disabled' : ''} mbx4`}
                            value={selectedAdminGroups[groupIndex].partners}
                            name="consignee"
                            label={t("home.addcollaborator.shipment_admin.label")}
                            // addButton={true}
                            options={partners ? partners.map(item => {
                                return {
                                    email: item.email,
                                    id: item._id || new Date().getTime().toString(),
                                    icon: item._id ? (item.type === MEMBER_U ? (item.avatar ? item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                                    title: item._id ? item.name : item.email,
                                    description: item._id ? (item.type === MEMBER_U ? item.email : item.name) : inviteByEmail,
                                    type: item.type
                                }
                            }) : []}
                            // addButtonLabel="Add"
                            onInputChange={value => getMembersTeams(value)}
                            // searchLoading={memberLoading[0] || teamLoading[0]}
                            labelIcon='icon-admin'
                            placeholder={t("home.addcollaborator.placeholder")}
                            // register={register()}
                            onChange={items => {
                                handleChoosePartners(items, groupIndex, SHIPMENT_ADMIN);
                            }}
                            mode="select"
                            renderList={members => (
                                <div className="tr__partners d-flex flex-wrap mtx1">
                                    {members.map((member, memberIndex) => (
                                        <div className="tr__partners--item col-12 d-flex justify-content-between align-items-center mbx2" key={memberIndex}>
                                            <div className="d-flex align-items-center">
                                                <i className="icon-times mrx3" onClick={() => handleRemovePartner(groupIndex, member.id, SHIPMENT_ADMIN)}></i>
                                                {member?.type === TEAM.toUpperCase() ? <span className="icon-users mrx2"></span> : <img src={member?.avatar} alt={"avatar"} />}
                                                <h3 className="f-medium h3">{member.name}</h3>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        />
                    </div>
                ))}

                <div className="col-4">
                    <p className="tr__link mbx2" onClick={handleAddGroupAdmin}>
                        <i className="icon-plus mrx1" />
                        <span>{t('Add more shipment admin')}</span>
                    </p>
                </div>
            </div>
            </div>
                <div className="col-12 px2 d-flex flex-wrap">
                {groups.map((group, groupIndex) => (
                    <div className="col-4" key={groupIndex}>
                        <Dropdown
                            className="select big-label px4"
                            icon="icon-chevron-down"
                            iconPosition="right"
                            mode="input"
                            name="organization"
                            label={t("home.active-shipment.choose-your-organization")}
                            options={organizations && organizations.length > 0 ? organizations.map(org => {
                                return {
                                    key: org._id,
                                    value: org.name
                                }
                            }) : []}
                            placeholder={t("home.active-shipment.select-organization")}
                            dropdownPosition="center"
                            onChange={value => handleChooseOrg(value, groupIndex)}
                            onInputChange={onSearchOrganization}
                            // searchLoading={orgLoading}
                            // refs={register({ required: !markAsShipmentTemplate })}
                            // refs={register({ required: true })}
                        // error={!!errors.organization}
                        // errorMessage={getErrorMessage(errors.organization, "Organization")}
                        />
                        <MultiSelect
                            className={`${!selectedGroups[groupIndex]?.orgId ? 'disabled' : ''} mbx4`}
                            value={selectedGroups[groupIndex].partners}
                            name="consignee"
                            label={t("home.addcollaborator.custom.label")}
                            // addButton={true}
                            options={partners ? partners.map(item => {
                                return {
                                    email: item.email,
                                    id: item._id || new Date().getTime().toString(),
                                    icon: item._id ? (item.type === MEMBER_U ? (item.avatar ? item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                                    title: item._id ? item.name : item.email,
                                    description: item._id ? (item.type === MEMBER_U ? item.email : item.name) : inviteByEmail,
                                    type: item.type
                                }
                            }) : []}
                            // addButtonLabel="Add"
                            onInputChange={value => getMembersTeams(value)}
                            // searchLoading={memberLoading[0] || teamLoading[0]}
                            labelIcon='icon-admin'
                            placeholder={t("home.addcollaborator.placeholder")}
                            // register={register()}
                            onChange={items => {
                                handleChoosePartners(items, groupIndex);
                            }}
                            mode="select"
                            renderList={members => (
                                <div className="tr__partners d-flex flex-wrap">
                                    {members.map((member, memberIndex) => (
                                       <div className="tr__partners--item col-12 d-flex justify-content-between align-items-center mbx2" key={memberIndex}>
                                           <div className="d-flex align-items-center">
                                               <i className="icon-times mrx3" onClick={() => handleRemovePartner(groupIndex, member.id)}></i>
                                               {member?.type === TEAM.toUpperCase() ? <span className="icon-users mrx2"></span> : <img src={member?.avatar} alt={"avatar"} />}
                                               <h3 className="f-medium h3">{member.name}</h3>
                                           </div>
                                           <Input 
                                                placeholder="Please enter the custom role..."
                                                onChange={(e) => handleChangeRoleName(e.target.value, groupIndex, memberIndex)}
                                                maxLength={50}
                                                name={`customRole-${groupIndex}-partner-${memberIndex}`}
                                                refs={register({ required: true })}
                                                error={!!errors[`customRole-${groupIndex}-partner-${memberIndex}`]}
                                                errorMessage={getErrorMessage(errors[`customRole-${groupIndex}-partner-${memberIndex}`], "custom role")}
                                                // value={selectedGroups[groupIndex].partners[memberIndex].role}
                                            />
                                       </div>
                                    ))}
                                </div>
                            )}
                        />
                    </div>
                ))}

                <div className="col-4">
                    <p className="tr__link mbx2" onClick={handleAddGroup}>
                        <i className="icon-plus mrx1" />
                        <span>{t('Add more custom role')}</span>
                    </p>
                </div>


            </div>
            
                
            </div>
        </div>
    )
};

AddPartnersForm.propTypes = {
    register: PropTypes.func,
    selectedValues: PropTypes.array,
    setSelectedValues: PropTypes.func,
    shipmentDetail: PropTypes.object
}
